import React, { useContext } from "react";
import { DataContext } from '../providers/dataProvider';
import { PopUpContext } from '../providers/popUpProvider';
import lc from "../cmprtbl.module.scss";

function SubRows( { data, style } ) {
  const ctx = useContext( DataContext );
  const { data: { gui } } = ctx;
  const popUpCtx = useContext( PopUpContext );
  const { setPopUp } = popUpCtx;
  const { features } = data;

  return (
    <div className={ lc.subrows } style={ style }>
      { features.map( ( row, index ) => (
        <div className={ lc.tr } key={ index }>
          { row.heading && (
            <div className={ lc.th }>
                <span className={ lc.heading }>{ row.heading }</span>
            </div>
          ) }

          { ! row.heading && (
            <>
              <div className={ lc.th }>
                  <span>{ row.name }</span>

                  { row.popup && (
                    <button type="button" className={ lc.popup_toggle } onClick={ () => setPopUp( row ) }>{ gui.detailsLinkText }</button>
                  ) }
              </div>
              
              <div className={ lc.tr }>
                  { row.levels && row.levels.map( ( value, levelIndex ) => (
                      <div className={ lc.td } key={ levelIndex }>
                          <span className={ ( value !== 0 ) ? ( ( value === 1 ) ? lc.level_icon_yes : lc.level_icon_optional ) : lc.level_icon_no }></span>
                      </div>
                  ) ) }
              </div>
            </>
          ) }
      </div>
      ) ) }
    </div>
  );
}

export default SubRows;
